import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenFindAi as ScreenFindAiFemale } from '../../../OwnAI/screens/FindAi';
import { ScreenFindAi as ScreenFindAiMale } from '../../../OwnAIMan/screens/FindAi';
import { LayoutDataType } from '../../types';

export const ScreenFindAi: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenFindAiMale />;
  }

  return <ScreenFindAiFemale />;
};
